// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1Rmgr","row":"ProcedureTreatmentSummary_row__1VNX5"};